import { TargetMarketId } from '@alkem/lib-front-model';

import CustomAutocomplete from 'components/ui/autocomplete/custom';
import * as targetMarkets from 'constants/targetMarkets';
import referentialApi from 'resources/referentialApi';
import i18n from 'utils/i18n';

export default class TargetMarketAutocomplete extends CustomAutocomplete {
  static defaultProps = Object.assign({}, CustomAutocomplete.defaultProps, {
    searchOnClick: true,
  });

  getList(search: string) {
    const onlyInclude = [
      targetMarkets.FRANCE,
      targetMarkets.SPAIN,
      targetMarkets.GERMANY,
      targetMarkets.UNITED_KINGDOM,
      targetMarkets.IRELAND,
      targetMarkets.REUNION,
      targetMarkets.PORTUGAL,
      targetMarkets.GLOBAL_MARKET,
      targetMarkets.UNITED_STATES,
      targetMarkets.AUSTRALIA,
      targetMarkets.CHILE,
      TargetMarketId.CANADA,
      TargetMarketId.MEXICO,
      TargetMarketId.COLOMBIA,
      TargetMarketId.PERU,
      TargetMarketId.COSTA_RICA,
      TargetMarketId.BRAZIL,
    ];

    referentialApi
      .ReferentialGetList('targetmarkets', {
        search,
        only_include: onlyInclude.join(),
      })
      .then((response) => {
        this.updateList(
          response.data.data.toJS().map((market) => {
            let label = market.description || market.label;
            if (market.id === targetMarkets.GLOBAL_MARKET) {
              label = i18n.t(
                'frontproductstream.target_market_autocomplete.global_market.label',
                { defaultValue: 'Global Market for Travel Retail' },
              );
            }

            return {
              id: market.id,
              label,
              value: market,
            };
          }),
        );
      });
  }
}
